import React from "react";
import { ListChecks } from "lucide-react";

// Calm, non-alarming nudge to tidy saved "Needs review" items. Hidden at count 0.
export default function ReviewNudgeChip({ count, onClick, fullWidth }) {
  if (!count || count <= 0) return null;
  return (
    <button
      data-testid="review-nudge-chip"
      onClick={onClick}
      className={`inline-flex items-center justify-center gap-2 rounded-full bg-[var(--line2)] hover:bg-[var(--pine-soft)] text-[var(--ink3)] px-3.5 py-2 text-sm font-medium transition-colors duration-200 ${
        fullWidth ? "w-full md:w-auto" : ""
      }`}
      title="Open your saved items to review"
    >
      <ListChecks size={15} strokeWidth={1.9} className="text-[var(--ink3)]" />
      {count} {count === 1 ? "item" : "items"} to review
    </button>
  );
}
